import React from "react"
import { Route, Switch } from "react-router-dom"
import AppliedRoute from "./components/shared/AppliedRoute"
import UnauthenticatedRoute from "./components/shared/UnauthenticatedRoute"
import ForgotPasswordRoute from "./components/shared/ForgotPasswordRoute"
import HomeContainer from "./containers/HomeContainer"
import NotFound from "./components/NotFoundPage"
import LoginContainer from "./containers/LoginContainer"
import PopupBlockPage from "./components/PopupBlockPage"
import ForgotPasswordContainer from "./containers/ForgotPasswordContainer"

const expDefRou = ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={HomeContainer} props={childProps} />
    <UnauthenticatedRoute path="/login" exact component={LoginContainer} props={childProps} />
    <ForgotPasswordRoute path="/forgotPassword" exact component={ForgotPasswordContainer} props={childProps} />
    <AppliedRoute path="/popup-block" exact component={PopupBlockPage} props={childProps} />
    <Route component={NotFound} />
  </Switch>

export default expDefRou